import { useNavigate } from "react-router-dom";

import { useSession } from "0.Mine/2.Context/sessionContext";
import axiosInstance from "0.Mine/axiosInstance";

import { Employee } from "../../3.Interfaces/Employee";
import { omit, omitProperty } from "../utils/omit";

import { useHandleImageUpload } from "./images";

export const useHandleBusinessEmployees = () => {
  const { session } = useSession();
  const { uploadImageEmployee } = useHandleImageUpload();
  const navigate = useNavigate();
  if (!session) {
    navigate("/signin", { replace: true });
  }
  const userid = session.user.id;
  const token = session.user.token;

  const addEmployee = async (businessId: number, data: Employee) => {
    const employeeDataWithoutId = omit(data, ["id", "serviceNames"]);
    console.log("EMPLOYEE WITHOUT ID: ", employeeDataWithoutId);
    const payloadForQuery: Record<string, any> = {
      userid: userid,
      token: token ?? "",
      businessid: businessId,
      action: "addone",
      data: JSON.stringify(employeeDataWithoutId),
    };

    try {
      const queryString = new URLSearchParams(payloadForQuery).toString();
      const response = await axiosInstance.post(`POST/employees.php?${queryString}`);
      console.log(response);
      const id = response.data.collaborators[0].id as string;
      await uploadImageEmployee(data.pic, id, businessId.toString());
    } catch (error) {
      console.error(error);
    }
  };

  const getAllEmployees = async (businessId: number) => {
    const payloadForQuery: Record<string, any> = {
      userid: userid,
      token: token ?? "",
      businessid: businessId,
    };

    try {
      const queryString = new URLSearchParams(payloadForQuery).toString();
      const response = await axiosInstance.get(`GET/employees.php?${queryString}`);
      console.log("EMPLOYEES:", response.data);
      return response.data.employees as Employee[];
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const editEmployee = async (businessId: number, employeeId: number, data: Employee) => {
    const payloadForQuery: Record<string, any> = {
      userid: userid,
      token: token ?? "",
      businessid: businessId,
      data: JSON.stringify(data),
      id: employeeId,
    };

    try {
      const queryString = new URLSearchParams(payloadForQuery).toString();
      const response = await axiosInstance.post(`POST/employees.php?${queryString}`);
      console.log(response);
    } catch (error) {
      console.error(error);
    }
  };

  return { getAllEmployees, addEmployee, editEmployee };
};
